import * as React from 'react'

import * as styles from './imagePlaceholder.module.css'

interface IProps {
  ratio?: number
  className?: string
  children?: any
}

const ImagePlaceholder = ({ ratio = 1, className = '', children }: IProps) => (
  <div
    className={`${styles.root} ${className}`}
    style={{ paddingTop: `${ratio * 100}%` }}
  >
    {children}
  </div>
)

export default ImagePlaceholder
